import { MOCK } from "utils/constants";
import instanceAuth from "./auth";
import instanceAuthMock from "./auth.mock";

const AUTH = MOCK ? instanceAuthMock : instanceAuth;

export default AUTH;
